import {
    StyledDivider,
    StyledFixedMenuItem,
    StyledHamburgerIcon,
    StyledMenuItem,
} from '../ContentNavMenuItem.styled'
import React, { FC } from 'react'
import { ProviderChildProps } from '@news-mono/component-library'

interface HamburgerMenuItemProps {
    flyOutProps?: ProviderChildProps
}

export const HamburgerMenuItem: FC<HamburgerMenuItemProps> = ({
    flyOutProps,
}) => {
    const handleOpenFlyout = () => {
        if (!flyOutProps) {
            return undefined
        }

        if (flyOutProps.mainNavOpen) {
            flyOutProps.closeNavigation()
        } else {
            flyOutProps.openNavigation()
        }
    }

    return (
        <StyledFixedMenuItem>
            <StyledMenuItem
                isSelected={false}
                onClick={() => handleOpenFlyout()}
            >
                <StyledHamburgerIcon />
            </StyledMenuItem>
            <StyledDivider />
        </StyledFixedMenuItem>
    )
}
